import React, { useState } from "react";
import "./Deliver.css";

export default function Deliver() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const cards = [
    {
      id: 1,
      title: "Product Strategy & Consulting",
      description:
        "Strong products start with clear thinking, not assumptions.",
      features: [
       "Clarify business goals, user needs, and technical feasibility early.",
"Use MVP consulting services to reduce risk before heavy investment.",
"Build a roadmap that aligns product vision with market demand."
      ],
    },
    {
      id: 2,
      title: "MVP Planning and Validation",
      description:
        "Test ideas early, learn fast, and build only what matters.",
      features: [
       "Define core features that solve real user problems.",
"Validate assumptions with rapid MVP builds and user feedback.",
"Shorten time-to-market without cutting critical corners."
      ],
    },
    {
      id: 3,
      title: "UI/UX Design for Real Users",
      description:
        "Design that feels intuitive, not just visually appealing.",
      features: [
        "User research and journey mapping to guide design decisions.",
"Interfaces built for usability, engagement, and conversion.",
"Consistent design systems that scale as products grow.",
      ],
    },
    {
      id: 4,
      title: "End-to-End Product Development",
      description: "From code to deployment, everything works together.",
      features: [
       "Frontend and backend development using modern, reliable stacks.",
"Secure architecture built to handle real-world usage.",
"Product development services focused on performance and scalability."
      ],
    },
    {
      id: 5,
      title: "Product Modernization & Scaling",
      description:
        "Evolve your product without starting from scratch.",
      features: [
       "Upgrade legacy systems for speed, security, and stability.",
"Improve performance as users and data grow.",
"Support long-term growth with flexible, cloud-ready architecture."
      ],
    },
    {
      id: 6,
      title: "Continuous Support & Improvement",
      description:
        "Products don’t stop at launch—and neither do we.",
      features: [
       "Ongoing monitoring, updates, and performance optimization.",
"Feature enhancements driven by real user behavior.",
"A product development company that stays invested beyond delivery."
      ],
    },
  ];

  return (
    <div id="product-deliver">
      <div className="deliver-container productmainclass">
        <h2 className="heading">
         Trusted Product Development Company Focused
on Real Outcomes
        </h2>
        <p className="subheading">
         Our product development company supports founders and enterprises with flexible product development services, using MVP consulting to test assumptions, refine features, and deliver market-ready digital products faster.
        </p>

        <div className="cards">
          {cards.map((card) => (
            <div className="card" key={card.id}>
              <h3>{card.title}</h3>
              <span>{card.description}</span>
              <ul>
                {card.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

       <div className="carousel-container">
          <div className="carousel-wrapper">
            <div
              className="carousel-track"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {cards.map((card) => (
                <div className="carousel-card" key={card.id}>
                  <h3>{card.title}</h3>
                  <span>{card.description}</span>
                  <ul>
                    {card.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="carousel-dots">
          {cards.map((_, index) => (
            <button
              key={index}
              className={`dot ${currentSlide === index ? "active" : ""}`}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
